import React from "react";
import useVerifySSOChanges from "../../hooks/useVerifySSOChanges";
import VerifySSOChangesLayout from "./VerifySSOChangesLayout";

const VerifySSOChanges = (): React.JSX.Element => {
  const { verificationStatus, onClose } = useVerifySSOChanges();

  return (
    <VerifySSOChangesLayout
      onClose={onClose}
      verificationStatus={verificationStatus}
    />
  );
};

export default VerifySSOChanges;
